import { firebaseAuth } from '@/services/firebase'
import { supabase } from '@/services/supabase'

export const authProvider = import.meta.env.VITE_AUTH_PROVIDER === 'supabase'
  ? 'supabase'
  : 'firebase'

export const passwordLoginEnabled = authProvider === 'supabase'
  && import.meta.env.VITE_SUPABASE_PASSWORD_LOGIN === 'true'

export const emailSignupEnabled = authProvider === 'supabase'
  && import.meta.env.VITE_SUPABASE_EMAIL_SIGNUP === 'true'

export async function accessToken(): Promise<string | null> {
  if (authProvider === 'supabase') {
    const { data, error } = await supabase?.auth.getSession() ?? { data: null, error: null }
    if (error) return null
    return data?.session?.access_token ?? null
  }
  return await firebaseAuth?.currentUser?.getIdToken() ?? null
}
